"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculationIntervalEnum = void 0;
var CalculationIntervalEnum;
(function (CalculationIntervalEnum) {
    CalculationIntervalEnum[CalculationIntervalEnum["CURRENT_MONTH"] = 0] = "CURRENT_MONTH";
    CalculationIntervalEnum[CalculationIntervalEnum["CURRENT_YEAR"] = 1] = "CURRENT_YEAR";
    CalculationIntervalEnum[CalculationIntervalEnum["ALL_TIME"] = 2] = "ALL_TIME";
})(CalculationIntervalEnum || (exports.CalculationIntervalEnum = CalculationIntervalEnum = {}));
